import { useEffect, useState } from 'react';

export const LiveInfo = ({ wind, biogas, pv, consumed }) => {
  const [liveInfo, setLiveInfo] = useState({});
  const surplusVal = wind + biogas + pv;
  const ratio = (surplusVal / consumed).toFixed(1).replace('.', ',');

  useEffect(() => {
    const myInterval = setInterval(() => {
      const date = new Date();
      const options = {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      };

      const time = new Intl.DateTimeFormat('de-DE', options).format(date);
      setLiveInfo({
        time,
      });
    }, 1000);
    return () => clearInterval(myInterval);
  });

  return (
    <div className='text-center my-4 mb-5'>
      <h4 className='fs-4 bold-font'>
        <span className='live-tag'>LIVE</span> {liveInfo.time}
      </h4>
      {consumed.toFixed(1) > 0 && surplusVal.toFixed(1) > 0 && (
        <p className='text-center fs-4 m-0'>
          Tengen versorgt sich <span className='bold-font'> {ratio} fach</span>{' '}
          erneuerbar
        </p>
      )}
    </div>
  );
};
